<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'site.blueprintTitle' | translate: {floor: itemS().name} }}
  </div>
  @if (!disabledS()) {
    <div class="flex flex-justify-between flex-align-center ion-margin-bottom">
      <p>{{ 'site.blueprintHelp' | translate }}</p>
      <ion-button color="light"
        (click)="changeBlueprint()">
        {{ 'site.changeBlueprint' | translate }}
      </ion-button>
    </div>
  }
  <div class="container">
    <div class="image-container">
      @if (imageElement()) {
        <app-area-map [imgElement]="imageElement()"
          [floor]="itemS().name"
          [site]="siteS()"></app-area-map>
      } @else {
        <img preserveAspectRatio="xMinYMin meet"
          [src]="itemS().url"
          (load)="setBlueprintImage($event)" />
      }
    </div>
  </div>
</app-main-dialog>